<template>
  <Transition
    :enter-class="$style.enter"
    :enter-active-class="$style.enterActive"
    :leave-to-class="$style.leaveTo"
    :leave-active-class="$style.leaveActive"
  >
    <nav v-show="isOpen" :class="$style.wrapper" :style="style">
      <ul :class="$style.menu">
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_cosmetics.png')"
          label="Cosmetics"
          subtitle="コスメ"
          to="https://i-voce.jp/cosmetics/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[5]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_skincre.png')"
          label="Skincare"
          subtitle="スキンケア"
          to="https://i-voce.jp/skincare/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[0]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_makeup.png')"
          label="Make-Up"
          subtitle="メイクアップ"
          to="https://i-voce.jp/make-up/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[1]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_bodycare.png')"
          label="Bodycare"
          subtitle="ボディケア"
          to="https://i-voce.jp/bodycare/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[2]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_hairNail.png')"
          label="Hair&amp;Nail"
          subtitle="ヘア＆ネイル"
          to="https://i-voce.jp/hair-nail/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[3]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_ranking.png')"
          label="Ranking"
          subtitle="ランキング"
          to="https://i-voce.jp/ranking/"
          :has-arrow="true"
          :is-thin="true"
          :child-links="childLinkList[6]"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_professional.png')"
          label="Beauty Professionals"
          subtitle="美容のプロ"
          to="https://i-voce.jp/professionals/"
          :has-arrow="false"
          :is-thin="true"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_videos.png')"
          label="Videos"
          subtitle="ビューティ動画"
          to="https://i-voce.jp/videos/"
          :has-arrow="false"
          :is-thin="true"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_present.png')"
          label="Presents"
          subtitle="プレゼント"
          to="https://i-voce.jp/presents/"
          :has-arrow="false"
          :is-thin="true"
        />
        <VcHeaderMenuItem
          :icon="require('@/assets/img/common/ico_gnav_latest-issue.png')"
          label="Latest Issue"
          subtitle="VOCE最新号"
          to="https://i-voce.jp/latest-issue/"
          :has-arrow="false"
          :is-thin="true"
        />
      </ul>
      <div :class="$style.footer">
        <ul :class="$style.subLink">
          <li>
            <a
              class="g-subtitle2"
              :class="$style.subLinkItem"
              href="https://i-voce.jp/faq/"
              >よくある質問</a
            >
          </li>
          <li>
            <a
              class="g-subtitle2"
              :class="$style.subLinkItem"
              href="https://i-voce.jp/enquete/?uecfcode=enq-2t4sub-97"
              target="_blank"
              >お問い合わせ</a
            >
          </li>
        </ul>
        <div :class="$style.sns">
          <div :class="$style.snsInner">
            <p class="pt-sans" :class="$style.snsTitle">FOLLOW US</p>
            <ul :class="$style.snsList">
              <li v-for="sns in snsLinks" :key="sns.name">
                <a
                  :class="[$style.snsIcon, sns.icon]"
                  :href="sns.link"
                  target="_blank"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        class="icon-xmark"
        :class="$style.close"
        @click="onCloseButtonClick"
      />
    </nav>
  </Transition>
</template>

<script>
  import snsLinks from "@/util/snsLinks";
  import VcHeaderMenuItem from "./VcHeaderMenuItem.vue";

  export default {
    components: {
      VcHeaderMenuItem,
    },
    props: {
      isOpen: {
        type: Boolean,
        required: false,
        default: false,
      },
      top: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data() {
      return {
        snsLinks,
        childLinkList: [
          [
            {
              name: "美容成分",
              to: "https://i-voce.jp/tags/beauty-ingredients/",
            },
            {
              name: "毛穴",
              to: "https://i-voce.jp/tags/keana/",
            },
            {
              name: "乾燥肌",
              to: "https://i-voce.jp/tags/kansouhada/",
            },
            {
              name: "ニキビ",
              to: "https://i-voce.jp/tags/nikibi/",
            },
            {
              name: "シワ",
              to: "https://i-voce.jp/tags/shiwa/",
            },
            {
              name: "炭酸コスメ",
              to: "https://i-voce.jp/tags/tansancosme/",
            },
            {
              name: "導入美容液",
              to: "https://i-voce.jp/tags/dounyubiyoueki/",
            },
            {
              name: "クレンジング",
              to: "https://i-voce.jp/tags/cleansing/",
            },
            {
              name: "乳液",
              to: "https://i-voce.jp/tags/nyueki/",
            },
          ],
          [
            {
              name: "アイシャドウ",
              to: "https://i-voce.jp/tags/eyeshadow/",
            },
            {
              name: "眉毛",
              to: "https://i-voce.jp/tags/mayuge/",
            },
            {
              name: "クッションファンデーション",
              to: "https://i-voce.jp/tags/cushionfoundation/",
            },
            {
              name: "プチプラコスメ",
              to: "https://i-voce.jp/tags/pettipr/",
            },
            {
              name: "リップ",
              to: "https://i-voce.jp/tags/lip/",
            },
            {
              name: "ブラシ",
              to: "https://i-voce.jp/tags/brush/",
            },
            {
              name: "新作コスメ",
              to: "https://i-voce.jp/tags/newcosme/",
            },
            {
              name: "チーク",
              to: "https://i-voce.jp/tags/cheek/",
            },
            {
              name: "パーソナルカラー",
              to: "https://i-voce.jp/tags/personal-color/",
            },
          ],
          [
            {
              name: "ダイエット",
              to: "https://i-voce.jp/tags/diet/",
            },
            {
              name: "お風呂美容",
              to: "https://i-voce.jp/tags/thebathbeauty/",
            },
            {
              name: "腸活",
              to: "https://i-voce.jp/tags/chokatsu/",
            },
            {
              name: "トレーニング",
              to: "https://i-voce.jp/tags/training/",
            },
            {
              name: "サプリ",
              to: "https://i-voce.jp/tags/sapli/",
            },
            {
              name: "肩こり",
              to: "https://i-voce.jp/tags/shouldar/",
            },
            {
              name: "ボディメイク",
              to: "https://i-voce.jp/tags/bodymake/",
            },
            {
              name: "ファスティング",
              to: "https://i-voce.jp/tags/fasting/",
            },
          ],
          [
            {
              name: "ヘアケア",
              to: "https://i-voce.jp/tags/haircare/",
            },
            {
              name: "ネイル",
              to: "https://i-voce.jp/tags/nail/",
            },
            {
              name: "ジェルネイル",
              to: "https://i-voce.jp/tags/gelnail/",
            },
            {
              name: "頭皮ケア",
              to: "https://i-voce.jp/tags/touhicare/",
            },
            {
              name: "白髪",
              to: "https://i-voce.jp/tags/grayhair/",
            },
            {
              name: "美容家電",
              to: "https://i-voce.jp/tags/biyoukaden/",
            },
          ],
          [
            {
              name: "メンズメイク",
              to: "https://i-voce.jp/tags/mensmake/",
            },
            {
              name: "メンズ美容",
              to: "https://i-voce.jp/tags/mensbiyou/",
            },
            {
              name: "インタビュー",
              to: "https://i-voce.jp/tags/interview/",
            },
            {
              name: "メンズコスメ",
              to: "https://i-voce.jp/tags/menscosme/",
            },
            {
              name: "SDGs",
              to: "https://i-voce.jp/tags/sdgs/",
            },
            {
              name: "マンガ",
              to: "https://i-voce.jp/tags/manga/",
            },
          ],
          [
            {
              name: "2025年上半期ベストコスメ",
              to: "https://i-voce.jp/bestcosme/",
            },
            {
              name: "秋コスメ特集【2025最新】",
              to: "https://i-voce.jp/special/autumnnewcolor/",
            },
            {
              name: "夏コスメ特集【2025最新】",
              to: "https://i-voce.jp/special/summernewcolor/",
            },
            {
              name: "メンズコスメ特集",
              to: "https://sp.i-voce.jp/special/mensbestcosme/",
            },
            {
              name: "コスメ発売日カレンダー",
              to: `https://i-voce.jp/cosmetics/calendar/weekly/${new Date().getFullYear()}${(
                "0" +
                (new Date().getMonth() + 1)
              ).substr(-2)}/`,
            },
            {
              name: "プロの目",
              to: "https://i-voce.jp/cosmetics/professional-reviews/",
            },
          ],
          [
            {
              name: "記事ランキング",
              to: "https://i-voce.jp/ranking/article/",
            },
            {
              name: "コスメランキング",
              to: "https://i-voce.jp/ranking/cosmetics/",
            },
          ],
        ],
      };
    },
    computed: {
      style() {
        return {
          top: this.top + "px",
        };
      },
    },
    methods: {
      onCloseButtonClick(event) {
        this.$emit("close", event);
      },
    },
  };
</script>

<style module>
  .wrapper {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #fff;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    z-index: 0;
  }

  .enter,
  .leaveTo {
    opacity: 0;
    transform: translateX(-200px);
  }
  .enterActive,
  .leaveActive {
    transition: all 0.2s ease;
  }

  .subLink {
    flex: 1 0 0;
    flex-grow: 1; /* IE対応 */
    margin: 8px 0 16px;
  }
  .subLinkItem {
    display: inline-block;
    width: 100%;
    height: 48px;
    padding-left: 68px;
    color: rgba(17, 17, 17, 0.54);
    line-height: 48px;
  }

  .sns {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    padding: 16px 0 26px;
    height: 104px;
    background: #f5f3f1;
  }
  .snsTitle {
    color: rgba(17, 17, 17, 0.33);
    font-size: 14px;
    line-height: 132%;
  }
  .snsList {
    display: flex;
    margin: 8px 0 0 -8px;
  }
  .snsIcon {
    color: rgba(17, 17, 17, 0.33);
    font-size: 48px;
  }
  .snsIcon::before {
    letter-spacing: -8px;
  }

  .close {
    appearance: none;
    flex: 0 0 auto;
    display: block;
    width: 100%;
    height: 48px;
    background-color: #fff;
    border: 0;
    color: rgba(17, 17, 17, 0.54);
    font-size: 48px;
  }

  @media screen and (min-width: 769px) {
    .enter,
    .leaveTo {
      opacity: 0;
      transform: translateY(-200px);
    }
    .menu {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      width: 100%;
      max-width: 1279px;
      position: relative;
    }
    .menu::after {
      content: "";
      width: 100vw;
      height: calc(100% - 145px);
      background-color: #faf9f8;
      position: absolute;
      top: 72px;
      left: 50%;
      transform: translateX(-50%);
      z-index: -2;
    }
    .menu > li:nth-child(5) {
      position: relative;
    }
    .menu > li:nth-child(5)::after {
      content: "";
      width: 150vw;
      height: 72px;
      background-color: #fff;
      position: absolute;
      top: 0;
      left: -100%;
      z-index: -1;
    }
    .footer {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 131px auto 0;
      max-width: 1279px;
      position: relative;
    }
    .footer::after {
      content: "";
      width: 100vw;
      height: 100%;
      background-color: #faf9f8;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
    }
    .subLink li {
      text-align: center;
      width: 26.1%;
    }
    .subLink {
      display: flex;
      margin: 0 0 0 5%;
    }
    .subLinkItem {
      margin: 0;
      padding: 0;
    }
    .sns {
      background: none;
      padding: 0;
      margin-right: 9.44%;
    }
    .snsInner {
      display: flex;
      align-items: center;
    }
    .snsTitle {
      margin-right: 10px;
    }
    .snsList {
      margin: 0;
    }
    .close {
      display: none;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 972px) {
    .menu::after {
      height: 394px;
    }
  }
</style>
